/** Device pixel ratio used for UI canvases (capped: 3x is already sharp, more only costs memory). */
function canvasPixelRatio(): number {
  return Math.min(3, window.devicePixelRatio || 1);
}

/**
 * Sizes a canvas backing store for a CSS box of `width` x `height`, clears it and returns a
 * context whose units are CSS pixels. Resizing only happens when needed (it resets the canvas).
 */
export function prepareCanvas(
  canvas: HTMLCanvasElement,
  width: number,
  height: number,
): CanvasRenderingContext2D | null {
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  const ratio = canvasPixelRatio();
  const pixelWidth = Math.max(1, Math.round(width * ratio));
  const pixelHeight = Math.max(1, Math.round(height * ratio));
  if (canvas.width !== pixelWidth) canvas.width = pixelWidth;
  if (canvas.height !== pixelHeight) canvas.height = pixelHeight;
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.clearRect(0, 0, pixelWidth, pixelHeight);
  ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
  return ctx;
}
